export default __webpack_public_path__ + "static/media/Pilgrim's Gauntlets of the Soaring Heart.375ff091.jpg";